import { z } from 'zod';

export const positionBriefModificationSchema = z.object({
  emailAddresses: z.array(z.string()),
});
